import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import tableData from "../../../utils/strucuture/operatoriData.json";
import {
  selectError,
  selectIsLoading,
  selectOperatori,
} from "../../../features/operatori/operatoriSlice";
import {
  fetchOperatori,
  deleteOperatoriData,
} from "../../../features/operatori/operatoriThunk";
import { useEffect } from "react";
import { fetchCompanies } from "../../../features/company/companyThunk";

const Operatori = () => {
    const columns = [
        { field: "nome", headerName: "Nome", width: 600 },
        { field: "cognome", headerName: "Cognome", width: 300 },
        { field: "email", headerName: "Email", width: 300 },
        { field: "abilitazioni", headerName: "Abilitazioni", width: 300 },
        { field: "azioni", headerName: "Azioni", width: 100, sortable: false }
    ];


  const dispatch = useDispatch();
  const operatori = useSelector(selectOperatori);
  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
  const isLoading = useSelector(selectIsLoading);
  const error = useSelector(selectError);

  useEffect(() => {
    dispatch(fetchCompanies())
  },[])

  useEffect(() => {
    dispatch(fetchOperatori({ role_id: "OPERATOR" }));

  }, [dispatch, selectSelectedCompany]);

  const transformedData = operatori
  ?.filter(op => op.role_id === "OPERATOR")
  .map((op) => ({
    id: op.id,
    nome: op.name || "-",
    cognome: op.surname || "-",
    email: op.email || "-",
    abilitazioni: op.user_details?.qualification || "-",
    azioni: "...",
  }));


    return (
        <>
            <div className="pageTemplate">
              
                <Table
                  data={transformedData}
                  columns={columns}
                  navData={"strucutreOperatori"}
                  deleteFunctions={"deleteOperatoriData"}
                />
          
            </div>
        </>
    );
};

export default Operatori;
